export default __webpack_public_path__ + "static/media/136.7a083a4d.jpg";